<template>

    <section id="new_ref_fifth_step" class="flex">

        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentPosition.name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.positions.formStep4.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero container ">
            <div class="hero-body">
                <div id="position_use_custom_email" v-if="currentPosition">

                    <div class="email_inputs_container" v-if="canAccessCustomisation">

                        <h2 class="title is-size-1 has-text-weight-bold stepTitle has-text-centered">
                            {{ $t('modules.positions.formStep4.title') }}
                        </h2>

                        <div class="custom_email_mini_container">
                            <notifText class="notice_custom_email" >
                                <span v-html="$t('modules.positions.formStep4.notice')"></span>
                            </notifText>
                            <br>
                            <br>
                            <SwitchInput switchId="email_custom_enabled"
                                class="custom_email_switch"
                                :switchLabel="$t('modules.positions.formStep4.radioLabel')"
                                :falseValue="false"
                                :trueValue="true"
                                :value="currentPosition.use_custom_email"
                                @change="handleSwitch" />

                            <transition name="fade">
                                <div class="custom_email_inputs" v-if="currentPosition.use_custom_email">
                                    <InputMaterialWrap
                                        v-model="emailSubject"
                                        :label="$t('modules.positions.formStep4.subjectLabel')"
                                        input-id="contactEmailSubject" />

                                    <TextareaMaterialWrap
                                        v-model="emailContent"
                                        :label="$t('modules.positions.formStep4.contentLabel')"
                                        input-id="contactEmailContent" />

                                </div>
                            </transition>
                        </div>

                    </div>
                    <div class="email_not_autorized" v-else >
                        <h2 class="title is-size-1 has-text-weight-light stepTitle has-text-centered">{{ $t('modules.positions.formStep4.title') }}</h2>
                        <notifText class="has-text-centered" v-html="$t('modules.positions.formStep4.noAccessNotice')" />
                    </div>

                    <div class="next_step_button has-text-centered" v-if="isNew">
                        <btn-circle-icon
                            class="large is-cursor"
                            icon="icon-arrow-right"
                            @click.native="nextStep" />
                    </div>

                </div>

            </div>
        </div>
    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'formEvalStep4',
    props: ['isNew'],
    components: {
        titlePage
    },
    data(){
        return {
            canAccessCustomisation: userCanAccess('extra', 'customisation')
        }
    },
    mounted(){
        this.$store.commit('PositionStore/updateFormValidity', { index: 3, validity: true } )
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        associatedRef(){
            return this.$store.state.PositionStore.associatedRef
        },
        emailSubject: {
            get(){
                return this.currentPosition.email_subject
            },
            set(value){
                this.$store.commit('PositionStore/updatePositionData', {email_subject: value} )
            }
        },
        emailContent: {
            get(){
                return this.currentPosition.email_content
            },
            set(value){
                this.$store.commit('PositionStore/updatePositionData', {email_content: value} )
            }
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        handleSwitch(id, value){
            this.$store.commit('PositionStore/updatePositionData', {use_custom_email: value} )
        },
        nextStep(){
            this.$store.commit('PositionStore/changeCurrentStep', { index: 4 })
        }
    }
}

</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;
    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}
#position_use_custom_email{
    .input, textarea, .notification{
        border-radius: 6px;
    }
    textarea{
        min-height: 300px;
    }
}

.custom_email_mini_container{
    max-width: 450px;
    margin: 0 auto;
    .custom_email_switch{
        margin-bottom: 50px!important;
    }
}

</style>